export default __webpack_public_path__ + "static/media/assessment-fill.82603f94.svg";